module.exports = __webpack_public_path__ + "13_hair_silver.cf00cf83.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/13_hair_silver.png
// module id = cBUa
// module chunks = 0